import { useContext, Children, cloneElement, isValidElement } from "react";
import FormContext from "../context/FormContext";

export function useInjectFormProps() {
    const { formData, updateFormData } = useContext(FormContext);

    const handleChange = (e) => {
        const { value } = e.target;
        const errorElement = e.target.closest(".error");
        if (errorElement) {
            errorElement.classList.remove("error");
        }

        if (e.target.type === "checkbox") {
            updateFormData({ [e.target.name]: e.target.checked })
        }
        else {
            updateFormData({ [e.target.name]: value })
        }
    }

    const injectFormProps = (children) => {
        return Children.map(children, (child) => {
            if (isValidElement(child)) {
                // Add form props to form-related components
                if (child.props?.identifier) {
                    return cloneElement(child, {
                        value: child.props.value !== undefined ? child.props.value : formData[child.props.identifier] || "",
                        name: child.props.identifier,
                        onChange: handleChange,
                    });
                }

                // Recurse through nested children
                if (child.props?.children) {
                    return cloneElement(child, {
                        children: injectFormProps(child.props.children),
                    });
                }
            }
            return child; // Return non-form elements as-is
        });
    };

    return { injectFormProps };
}
